import { Migration_1_EnsureWorkspaceCrypto } from './migrations/1.ensure-workspace-crypto';
import { Migration_2_EnsureWorkspaceKeySetInAllInvitations } from './migrations/2.ensure-workspace-key-set-in-invitations';
import { Migration_3_EnsureDomainKeysForVerifiedDomains } from './migrations/3.ensure-domain-keys-for-verified-domains';
export class CryptoMigrator {
    adminCrypto;
    migrations;
    constructor(adminCrypto, workspaceFetcher) {
        this.adminCrypto = adminCrypto;
        this.migrations = [
            new Migration_1_EnsureWorkspaceCrypto(adminCrypto, workspaceFetcher),
            new Migration_2_EnsureWorkspaceKeySetInAllInvitations(adminCrypto, workspaceFetcher),
            new Migration_3_EnsureDomainKeysForVerifiedDomains(adminCrypto, workspaceFetcher),
        ];
    }
    async migrate() {
        for (const migration of this.migrations) {
            if (await migration.shouldExecute()) {
                await migration.execute();
                await this.adminCrypto.adminMember.refresh();
            }
        }
    }
}
